


























import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import nodeModule from '@/store/modules/entities/nodeModule';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {PModuleType} from '@/enums/configs';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';

@Component({
  components: {
    EditDialog,
    SelectionList,
  },
})
export default class CleanModuleSettingsEditDialog extends Mixins(EditDialogMixin) {
  @Prop()
  nodeId!: number;

  @Prop()
  pmodules!: any[];

  @Prop({required: false, default: false})
  filterModules?: boolean;

  @Prop({required: false, default: false})
  filterTasks?: boolean;

  @Prop({required: false, default: true})
  showCheckboxWithTooltip?: boolean;

  allPmodules: any[] = [];

  childPModules: PModuleWithMeasurements[] = [];

  showChildPM = false;

  @Watch('pmodules')
  async onPmodulesChange(newVal: any) {
    if (!newVal.length) return;
    this.allPmodules = this.pmodules;
    if (this.filterModules)
      this.allPmodules = this.allPmodules.filter(x => x.type == PModuleType.HeaterMonitorModule);

    if (this.filterTasks)
      this.allPmodules = this.allPmodules.filter(
        x => x.type == PModuleType.MonitorStatesTasks || x.type == PModuleType.MonitorBoundaryTasks,
      );

    if (!this.nodeId) this.childPModules = [];
    else {
      const childNodes = await nodeModule.getChildNodes(this.nodeId);
      const childNodesIds = childNodes.map(x => x.id);
      this.childPModules = this.allPmodules.filter(x => childNodesIds.includes(x.nodeId));
    }
  }

  changePMList(value: any) {
    this.showChildPM = value;
  }
}
